/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Withdrawal_FailedInputs */

const en_withdrawal_failed = /** @type {(inputs: Withdrawal_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not send your withdrawal. Please try again.`)
};

const pl_withdrawal_failed = /** @type {(inputs: Withdrawal_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie udało się wysłać odstąpienia. Spróbuj ponownie.`)
};

/**
* | output |
* | --- |
* | "Could not send your withdrawal. Please try again." |
*
* @param {Withdrawal_FailedInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const withdrawal_failed = /** @type {((inputs?: Withdrawal_FailedInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Withdrawal_FailedInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_withdrawal_failed(inputs)
	return en_withdrawal_failed(inputs)
});